import * as $ from "jquery";
import 'slick-carousel';

export default class PartnerTemplates {
  partnerTemplates: JQuery<HTMLElement>;
  
  constructor(domRoot: HTMLElement) {
    this.partnerTemplates = $('.partner-templates-carousel', domRoot);

    this.init();
  }

  init() {
    const arrowClass = `aui-icon aui-iconfont-arrow-up aui-icon-large
      partner-templates-carousel-btn`;
    const roundedArrowClass = 'partner-templates-carousel-btn-rounded';

    this.partnerTemplates.slick({
      prevArrow: `<span class="${arrowClass} btn-prev" />`,
      nextArrow: `<span class="${arrowClass} btn-next" />`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            prevArrow: `
              <button class="${roundedArrowClass} btn-prev-rounded">
                <span class="aui-icon aui-icon-small aui-iconfont-arrow-up">
                </span>
              </button>
            `,
            nextArrow: `
              <button class="${roundedArrowClass} btn-next-rounded">
                <span class="aui-icon aui-icon-small aui-iconfont-arrow-up">
                </span>
              </button>
            `
          }
        }
      ]
    });
  }
}
